module.exports = __webpack_public_path__ + "static/img/server8.aceaf583.jpg";